export default "__VITE_ASSET__Cx2h7C91__"